'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { memo, PropsWithChildren, useState } from 'react'
// For devtools:
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

export const qc = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000, // fresh for 60s => no refetch on next page
      gcTime: 5 * 60_000, // keep in memory 5m
      refetchOnWindowFocus: false,
      retry: false,
    },
    mutations: {
      retry: false, // optional: disables retries for mutations
    },
  },
})

export const TSQueryProvider = memo(({ children }: PropsWithChildren) => {
  // Important: keep QueryClient across page changes
  const [client] = useState(qc)

  return (
    <QueryClientProvider client={client}>
      {children}
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  )
})
